import { CurrencyCnyIcon } from './CurrencyCnyIcon';

/**
 * author: Google
 * id 0F5809A3-18DD-4B42-9A7E-B35B65EF3751
 * name currency-cny
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-cny.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const YuanIcon = CurrencyCnyIcon;
export default YuanIcon